import React,{useState} from 'react';
import {Col,Container,Form,Table} from 'react-bootstrap';
import p3 from './part3_data.json'
function Input(props){
    
}
function Answer_Form(props){
    
    const [supine,setSupine] = useState((props.data!=null&&props.data[props.name+'_supine']!='No Record')?props.data[props.name+'_supine']:"")
    const [standing,setStanding] = useState((props.data!=null&&props.data[props.name+'_standing']!='No Record')?props.data[props.name+'_standing']:"")
    const [checked,setCheck] = useState((props.data!=null&&props.data[props.name+'_supine'] == 'No Record' && props.data[props.name+'_standing'] === 'No Record' )?true:false)
    const [disabled,setDisabled] = useState((props.data!=null&&props.data[props.name+'_supine'] == 'No Record' && props.data[props.name+'_standing'] === 'No Record')?true:false)
   

    const handleCheck = async (event) =>{
        
        if(event.target.checked){
            props.noRecord(event.target.name)
            setCheck(event.target.checked)
           await setDisabled(true)
            setSupine("")
            setStanding("")
            
        }
        else {
            setCheck(event.target.checked)
            setDisabled(false)
        }
    }
    const handleChange = (event) =>{
        
        if(event.target.name === props.name+'_supine'){
            setSupine(event.target.value)
        }
        else{
            setStanding(event.target.value)
        }
        props.handler(event)
    }
    return(
            <div>
                <>
                    <Form.Label>Supine</Form.Label>
                    <Form.Control name={props.name+'_supine'} value={supine} onChange={handleChange} disabled={disabled||props.disabled}/>
                </>
                <>
                    <Form.Label>Standing</Form.Label>
                    <Form.Control name={props.name+'_standing'} value={standing} onChange={handleChange} disabled={disabled||props.disabled}/>
                </>
                <Form.Check label={'Unable to record'} name={props.name}checked={checked} onChange={handleCheck} disabled={props.disabled}/>
            </div>
        
    )
}
function TextField(props) {
    const [value,setVal] = useState(props.data!=null?props.data["p3_orthostatic_symptoms"]:"")
    const handleChange = (event) =>{
        setVal(event.target.value)
        props.handler(event)
    }
    return (
        <Form.Group>
                           <Form.Control as="select" name={"p3_orthostatic_symptoms"} onChange={handleChange} value={value} disabled={props.disabled} >
                                <option></option>
                               <option>No</option>
                               <option>Yes</option>
                           </Form.Control>
                       </Form.Group>
    )
}

class Part3 extends React.Component {
    constructor(props) {
        super(props)
        this.state ={

        }
        this.onChange = this.onChange.bind(this)
    }
    handleNoRecord = (name) => {
        this.setState((prevState)=>({
            ...prevState,
            [name+'_standing']:"No Record",
            [name+'_supine']:"No Record"
        }))
    }
    onChange (event) {
       
        const {name, value} = event.target
        this.setState((prevState)=>({
            ...prevState,
            [name] : value
        }))
    }
    componentDidUpdate(prevProps,prevState){
        if (prevState != this.state){
            this.props.hanlder(this.state)
        }
    }
    componentDidMount() {
    }

    render() {
       
        return (
            <div>
                <Form.Row>
                    <Col>
                        <h5>Systolic blood pressure</h5>
                    </Col>
                    <Col>
                        <Answer_Form  handler={this.onChange} data={this.props.data!=null?this.props.data:null} disabled={this.props.disabled} noRecord={this.handleNoRecord} name={'p3_systolic_blood_pressure'}/>
                    </Col>
                </Form.Row>
                <Form.Row>
                    <Col>
                        <h5>Diastolic blood pressure</h5>
                    </Col>
                    <Col>
                        <Answer_Form handler={this.onChange} data={this.props.data!=null?this.props.data:null} disabled={this.props.disabled} noRecord={this.handleNoRecord} name={'p3_diastolic_blood_pressure'}/>
                    </Col>

                </Form.Row>
                <Form.Row>
                    <Col>
                        <h5>Heart rate</h5>
                    </Col>
                    <Col>
                        <Answer_Form  handler={this.onChange} data={this.props.data!=null?this.props.data:null} disabled={this.props.disabled} noRecord={this.handleNoRecord}  name={'p3_heart_rate'}/>
                    </Col>
                </Form.Row>
                <br/>
                <Form.Row>
                    <Col>
                        <h5>Orthostatic symptoms</h5>
                    </Col>
                    <Col>
                        
                       <TextField handler={this.onChange} data={this.props.data} disabled={this.props.disabled}/>
                    </Col>
                </Form.Row>
            </div>
        )
    }
}
Part3.defaultProps = {
    data:null,
    disabled:false

}
export default Part3;